export const MAIN_WHATSAPP_MESSAGE = `Hola OA LOSAS, quiero cotizar.

Material y medida:
Cantidad aproximada:
Ciudad de entrega:
¿Requiero factura?:
¿Para cuándo lo necesito?`

export const DISTRIBUTOR_WHATSAPP_MESSAGE = `Hola OA LOSAS, tengo casa de materiales / compro por volumen y quiero precio de distribuidor.

Empresa:
Ciudad:
Materiales de interés:
Volumen mensual aproximado:`

export const RESERVE_WHATSAPP_MESSAGE = `Hola OA LOSAS, quiero apartar precio y confirmar disponibilidad.

Material y medida:
Cantidad aproximada:
Ciudad de entrega:
Fecha en que lo necesito:`

export interface FollowUpEmail {
  id: string
  timing: string
  subject: string
  body: string
  cta: string
}

export const EMAIL_SEQUENCE: FollowUpEmail[] = [
  {
    id: 'email-1',
    timing: 'Inmediato',
    subject: 'Recibimos tu solicitud en OA LOSAS',
    body: 'Aquí tienes nuestra lista de precios 2026 y el paso siguiente para recibir tu precio final. Recuerda: pedidos desde $5,000 llevan entrega sin costo. Responde este correo o escríbenos por WhatsApp con material, cantidad y ciudad.',
    cta: 'Continuar por WhatsApp',
  },
  {
    id: 'email-2',
    timing: '2 horas después',
    subject: '¿Ya sabes cuántas piezas necesitas?',
    body: 'Cada bovedilla de 63 x 300 cm cubre aproximadamente 1.89 m² brutos. Pásanos tus m² de losa y te calculamos piezas sin costo.',
    cta: 'Enviar mis m² por WhatsApp',
  },
  {
    id: 'email-3',
    timing: '24 horas después',
    subject: 'Bovedilla EPS desde $300 y entrega sin costo',
    body: 'Bovedilla 63 x 300: 12 cm $300, 13 cm $320, 15 cm $365, 19 cm $480, 24 cm $540. Casetón desde $20 y vigueta desde $110. Entrega sin costo desde $5,000 y facturamos.',
    cta: 'Pedir precio final',
  },
  {
    id: 'email-4',
    timing: '48 horas después',
    subject: 'Evita retrasos en tu colado',
    body: 'Si tu losa ya está programada, confirma disponibilidad y fecha de entrega con anticipación. También hacemos medidas personalizadas en altura y largo.',
    cta: 'Confirmar disponibilidad',
  },
  {
    id: 'email-5',
    timing: '5 días después',
    subject: '¿Sigues necesitando material para tu losa?',
    body: 'Cotizamos por pieza, por volumen o por m² de losa. Si eres constructor, contratista o distribuidor, pregunta por condiciones especiales.',
    cta: 'Retomar cotización',
  },
]

export interface FollowUpScript {
  id: string
  label: string
  text: string
}

export const WHATSAPP_SCRIPTS: FollowUpScript[] = [
  {
    id: 'inmediato',
    label: 'Mensaje inmediato',
    text: 'Hola, gracias por escribir a OA LOSAS. Manejamos bovedilla EPS 63 x 300 cm (12, 13, 15, 19 y 24 cm), casetón y vigueta. Para cotizarte bien, ¿me confirmas medida, cantidad, ciudad de entrega y si requieres factura? Pedidos desde $5,000 llevan entrega sin costo.',
  },
  {
    id: 'solo-precio',
    label: 'Si solo pregunta precio',
    text: 'Claro. Bovedilla 63 x 300: 12 cm $300, 13 cm $320, 15 cm $365, 19 cm $480 y 24 cm $540 por pieza. Desde $5,000 la entrega va sin costo. ¿Cuántas piezas necesitas y en qué ciudad es la obra?',
  },
  {
    id: 'seguimiento-24h',
    label: 'Seguimiento 24 horas',
    text: 'Hola, te doy seguimiento a tu cotización de OA LOSAS. ¿Revisamos precio y disponibilidad para tu obra? Si tu colado ya tiene fecha, conviene apartar hoy.',
  },
  {
    id: 'cierre',
    label: 'Mensaje de cierre',
    text: 'Puedo cerrar tu pedido hoy. Solo confirmo medida, cantidad, ciudad y fecha de entrega, y te lo programamos.',
  },
]
